import React, { useState } from 'react';
import './internationalcollaborations.css';
import doctorIcon from '../../../assets/icons/doctor-icon.svg';
import medicalKitIcon from '../../../assets/icons/medical-kit.svg';
import hospitalIcon from '../../../assets/icons/Hospital.svg';

const stats = [
  {
    label: 'Doctors',
    value: '20k',
    icon: doctorIcon,
    bgClass: 'card--orange',
  },
  {
    label: 'Medical Associations',
    value: '20k',
    icon: medicalKitIcon,
    bgClass: 'card--teal',
  },
  {
    label: 'Partner Hospitals',
    value: '20k',
    icon: hospitalIcon,
    bgClass: 'card--green',
  },
];

const countries = ['India', 'Ethiopia'];

export const Internationalcollaborations = () => {
  const [activeCountry, setActiveCountry] = useState('India');

  return (
    <section className="intl-collab">
      <h2 className="intl-collab__title">International Collaborations</h2>
      <p className="intl-collab__subtitle">
        Learn from leading doctors and specialists through focused, digestible video content.
      </p>

      <div className="intl-collab__tabs">
        {countries.map((country) => (
          <button
            key={country}
            className={`intl-collab__tab ${activeCountry === country ? 'intl-collab__tab--active' : ''}`}
            onClick={() => setActiveCountry(country)}
          >
            {country}
          </button>
        ))}
      </div>

      <div className="intl-collab__cards">
        {stats.map((stat) => (
          <div key={stat.label} className={`intl-collab__card ${stat.bgClass}`}>
            <span className="intl-collab__card-label">{stat.label}</span>
            <div className="intl-collab__card-text">
              <span className="intl-collab__card-value">{stat.value}</span>
              <img src={stat.icon} alt={stat.label} className="intl-collab__card-icon" />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
